'use strict';

var styled = require('styled-components');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const StyledTable = styled__default.default.table `
  border-radius: ${({ theme }) => theme.radiuses.m};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: inline-table;
  min-width: 100%;
`;
const Wrapper = styled__default.default.div `
  overflow: hidden;
  overflow-x: auto;
  max-width: 100%;
`;
const DocTable = React.forwardRef((props, ref) => (React__default.default.createElement(Wrapper, null,
    React__default.default.createElement(StyledTable, { ...props, ref: ref }))));
const DocTableTh = styled__default.default.th `
  text-align: left;
  background: ${({ theme }) => theme.colors.disabled.background};
  padding: ${({ theme }) => theme.space.component.y.xs} ${({ theme }) => theme.space.component.x.s};
`;
const DocTableTr = styled__default.default.tr `
  background: ${({ theme }) => theme.colors.body.background};
`;
const DocTableTd = styled__default.default.td `
  padding: ${({ theme }) => theme.space.component.y.xs} ${({ theme }) => theme.space.component.x.s};
`;

exports.DocTable = DocTable;
exports.DocTableTd = DocTableTd;
exports.DocTableTh = DocTableTh;
exports.DocTableTr = DocTableTr;
//# sourceMappingURL=component.js.map
